var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-flex",
                [
                  _c("v-autocomplete", {
                    attrs: {
                      dense: "",
                      items: _vm.legacyContract.items,
                      "item-value": "id",
                      "item-text": "name",
                      label: "Contrat",
                      "return-object": ""
                    },
                    model: {
                      value: _vm.legacyContract.selected,
                      callback: function($$v) {
                        _vm.$set(_vm.legacyContract, "selected", $$v)
                      },
                      expression: "legacyContract.selected"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                [
                  _c("v-autocomplete", {
                    attrs: {
                      dense: "",
                      items: _vm.source_types,
                      label: "Type d'asset"
                    },
                    model: {
                      value: _vm.legacy_asset_selected,
                      callback: function($$v) {
                        _vm.legacy_asset_selected = $$v
                      },
                      expression: "legacy_asset_selected"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                [
                  _c("v-text-field", {
                    attrs: {
                      dense: "",
                      label: "Précision",
                      hint: "Une précision sur l'asset."
                    },
                    model: {
                      value: _vm.precision,
                      callback: function($$v) {
                        _vm.precision = $$v
                      },
                      expression: "precision"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                [
                  _c("v-select", {
                    attrs: {
                      dense: "",
                      items: _vm.qc_levels,
                      label: "Type de QC"
                    },
                    model: {
                      value: _vm.qc_type_selected,
                      callback: function($$v) {
                        _vm.qc_type_selected = $$v
                      },
                      expression: "qc_type_selected"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "background" },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mr-0 background--text",
                  attrs: {
                    disabled: _vm.disableSubmitButton,
                    color: "primary",
                    loading: _vm.submitLoading
                  },
                  on: {
                    click: function($event) {
                      _vm.submit()
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("\n\t\t\t\tEnvoyer\n\t\t\t")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33c67a7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c67a7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/jobs/launcher/job_launcher_form_legacy.vue
// module id = null
// module chunks = 